import { makeSubstitutionModule } from "./FormulaSubstitutionShared";

export const TYPE = "FormulaSubstitutionFractionTask";

const TEMPLATES = [
  {
    prompt: "Podstaw dane liczby do wzoru z ułamkiem i oblicz wynik.",
    formulaLatex: "s=\\frac{a+b}{2}",
    valuesLatex: "a=10,\\ b=18",
    answerSymbol: "s",
    answerLabelLatex: "s",
    answer: 14,
    substitutionLatex: "s=\\frac{10+18}{2}",
    resultLatex: "14",
  },
  {
    prompt: "Podstaw dane liczby do wzoru z ułamkiem i oblicz wynik.",
    formulaLatex: "P=\\frac{a\\cdot h}{2}",
    valuesLatex: "a=12\\ \text{cm},\\ h=5\\ \text{cm}",
    answerSymbol: "P",
    answerLabelLatex: "P",
    answer: 30,
    unitLatex: "cm^2",
    substitutionLatex: "P=\\frac{12\\cdot 5}{2}",
    resultLatex: "30",
  },
  {
    prompt: "Podstaw dane liczby do wzoru z ułamkiem i oblicz wynik.",
    formulaLatex: "v=\\frac{s}{t}",
    valuesLatex: "s=72\\ \text{km},\\ t=2\\ \text{h}",
    answerSymbol: "v",
    answerLabelLatex: "v",
    answer: 36,
    unitLatex: "km/h",
    substitutionLatex: "v=\\frac{72}{2}",
    resultLatex: "36",
  },
];

const moduleApi = makeSubstitutionModule(TYPE, TEMPLATES);

export const generateTask = moduleApi.generateTask;
export const renderTask = moduleApi.renderTask;
export const renderInput = moduleApi.renderInput;
export const checkAnswer = moduleApi.checkAnswer;
export const renderAnswer = moduleApi.renderAnswer;
export const renderUserAnswer = moduleApi.renderUserAnswer;
export const renderExplanation = moduleApi.renderExplanation;